import { Button, Content, ContentVariants, Stack, StackItem } from "@patternfly/react-core";
import type { FC } from "react";
import LinkIcon from "../../../assets/Icon-Red_Hat-Link-A-Red-RGB.svg";
import type { DragHandleProps } from "../../../constants/CardsStructure";
import Env from "../../../utils/env";
import { DashboardCard } from "../shared/DashboardCard";

const PROGRAM_LINKS = [
	{
		label: "Red Hat Specialized Partner Application",
		href: "https://www.feedback.redhat.com/jfe/form/SV_1RMAv520YDj4wg6",
	},
];

const ADDITIONAL_LINKS = [
	{ label: "Red Hat Partner FAQs", href: `${Env.AccessRedhatPortals[Env.getEnvName()]}articles/7141436` },
	{
		label: "Partner program guides and resources",
		href: "https://content.redhat.com/us/en/sales-enablement/partner-sales/partner-engagement-experience.html",
	},
	{ label: "Partner connect homepage", href: `${Env.ConnectPortalUrls[Env.getEnvName()]}` },
	{ label: "Customer portal", href: `${Env.AccessRedhatPortals[Env.getEnvName()]}` },
	{ label: "Developers", href: `${Env.DevelopersRedhatPortals[Env.getEnvName()]}` },
	{ label: "Red Hat Ecosystem Catalog", href: `${Env.CatalogPortals[Env.getEnvName()]}` },
];

const LinkSection: FC<{ title: string; links: { label: string; href: string }[] }> = ({ title, links }) => (
	<StackItem>
		<Content>
			<Content component={ContentVariants.h4} style={{ marginBottom: "4px" }}>
				{title}
			</Content>
		</Content>
		{links.map((link) => (
			<div key={link.label}>
				<Button
					component="a"
					href={link.href}
					target="_blank"
					variant="link"
					isInline
					style={{ fontSize: "var(--pf-t--global--font--size--sm)", paddingBlock: "2px" }}
				>
					{link.label}
				</Button>
			</div>
		))}
	</StackItem>
);

const OtherResourcesCardBody: FC = () => (
	<Stack hasGutter>
		<LinkSection title="Program links" links={PROGRAM_LINKS} />
		<LinkSection title="Additional links" links={ADDITIONAL_LINKS} />
	</Stack>
);

export const OtherResourcesCard: FC<{ dragHandleProps?: DragHandleProps | undefined }> = ({ dragHandleProps }) => (
	<DashboardCard
		icon={LinkIcon}
		title="Other resources"
		isLoading={false}
		cardBody={<OtherResourcesCardBody />}
		dragHandleProps={dragHandleProps}
	/>
);
